import { useTranslation } from 'react-i18next'

export const SuccessToast = ({ mssg }) => {
  const { t } = useTranslation()

  return <div>{t(mssg)}</div>
}
